// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ExportPrototypeModulesListRequestDTO from '../../dto/request/ExportPrototypeModulesListRequestDTO';

export default abstract class ExportPrototypeModulesListRequestModel extends BaseModel<ExportPrototypeModulesListRequestDTO> {
  // #region    ──BodyRequest──────────────────────────╮
  // #endregion ───────────────────────────────────────╯
  // #region    ──HeaderRequest──────────────────────────╮
  // #endregion ─────────────────────────────────────────╯
  // #region    ──QueryRequest──────────────────────────╮
  /**
  * @type {int64}
  */
  get classId() { return this.dto.classId; }
  set classId(value) { this.dto.classId = value; }
  /**
  */
  get classIds() { return this.dto.classIds; }
  set classIds(value) { this.dto.classIds = value; }
  /**
  * @type {int64}
  */
  get moduleId() { return this.dto.moduleId; }
  set moduleId(value) { this.dto.moduleId = value; }
  /**
  * @type {int64}
  */
  get lectureLessonStatusId() { return this.dto.lectureLessonStatusId; }
  set lectureLessonStatusId(value) { this.dto.lectureLessonStatusId = value; }
  /**
  * @type {int64}
  */
  get userId() { return this.dto.userId; }
  set userId(value) { this.dto.userId = value; }
  /**
  * @type {int64}
  */
  get lecturerId() { return this.dto.lecturerId; }
  set lecturerId(value) { this.dto.lecturerId = value; }
  /**
  * @type {int64}
  */
  get primaryLeadLecturerId() { return this.dto.primaryLeadLecturerId; }
  set primaryLeadLecturerId(value) { this.dto.primaryLeadLecturerId = value; }
  /**
  */
  get isPrototype() { return this.dto.isPrototype; }
  set isPrototype(value) { this.dto.isPrototype = value; }
  /**
  */
  get searchCriteria() { return this.dto.searchCriteria; }
  set searchCriteria(value) { this.dto.searchCriteria = value; }
  /**
  * @type {int32}
  */
  get 'paging.CurrentPage'() { return this.dto['paging.CurrentPage']; }
  set 'paging.CurrentPage'(value) { this.dto['paging.CurrentPage'] = value; }
  /**
  * @type {int32}
  */
  get 'paging.PageSize'() { return this.dto['paging.PageSize']; }
  set 'paging.PageSize'(value) { this.dto['paging.PageSize'] = value; }
  /**
  */
  get 'paging.IncludeCount'() { return this.dto['paging.IncludeCount']; }
  set 'paging.IncludeCount'(value) { this.dto['paging.IncludeCount'] = value; }
  /**
  */
  get 'paging.NoPaging'() { return this.dto['paging.NoPaging']; }
  set 'paging.NoPaging'(value) { this.dto['paging.NoPaging'] = value; }
  // #endregion ────────────────────────────────────────╯

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.classid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.classId = value;
    value = Number.parseFloat(qs.moduleid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.moduleId = value;
    value = Number.parseFloat(qs.lecturelessonstatusid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.lectureLessonStatusId = value;
    value = Number.parseFloat(qs.userid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.userId = value;
    value = Number.parseFloat(qs.lecturerid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.lecturerId = value;
    value = Number.parseFloat(qs.primaryleadlecturerid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.primaryLeadLecturerId = value;
    value = qs.isPrototype === 'true' ? true : qs.isprototype;
    value = qs.isPrototype === 'false' ? false : undefined;
    this.dto.isPrototype = value;
    this.dto.searchCriteria = qs.searchcriteria;
    value = Number.parseFloat(qs['paging.currentpage']);
    value = Number.isNaN(value) ? undefined : value;
    this.dto['paging.CurrentPage'] = value;
    value = Number.parseFloat(qs['paging.pagesize']);
    value = Number.isNaN(value) ? undefined : value;
    this.dto['paging.PageSize'] = value;
    value = qs['paging.IncludeCount'] === 'true' ? true : qs['paging.includecount'];
    value = qs['paging.IncludeCount'] === 'false' ? false : undefined;
    this.dto['paging.IncludeCount'] = value;
    value = qs['paging.NoPaging'] === 'true' ? true : qs['paging.nopaging'];
    value = qs['paging.NoPaging'] === 'false' ? false : undefined;
    this.dto['paging.NoPaging'] = value;
  }
}
